<template>
  <default-layout>
    <event-navbar title="Tickets" />
    <ticket-list />
  </default-layout>
</template>

<script>
import TicketList from '@/components/speaker/ticket-list.vue'
import EventNavbar from '@/components/EventNavbar.vue'
import DefaultLayout from '@/components/DefaultLayout.vue'

export default {
  name: 'TicketListView',
  components: { TicketList, EventNavbar, DefaultLayout },
}
</script>
